import * as Sentry from '@sentry/browser'
import { getPageOfIndex, requestPage } from 'components/InfinityTable/sagaUtils'
import lodash from 'lodash'
import { toast } from 'react-toastify'
import { all, put, select, takeEvery, takeLatest } from 'redux-saga/effects'

import { request } from '../../../1stlog-ui/src/utils'
import { receive, receiveAdd, setCurrentFilter } from './actions'
import { APPLY_FILTER, REQUEST, REQUEST_ADD } from './constants'
import {
  makeSelectCurrentFilter,
  makeSelectFilterClean,
  makeSelectLoadedPages,
} from './selectors'

const saga = 'containers/Addressbook/saga'
const selectLoadedPages = makeSelectLoadedPages()
const selectFilterClean = makeSelectFilterClean()

export default function* root() {
  try {
    yield all([
      takeLatest(REQUEST_ADD, handleRequestAdd),
      takeEvery(REQUEST, handleRequest),
      takeEvery(APPLY_FILTER, handleApplyFilter),
    ])
  } catch (error) {
    console.error(error)
    Sentry.captureMessage(error, { extra: { error, saga } })
  }
}

export function* handleRequest({
  payload,
  payload: { startIndex, stopIndex, isManual },
}) {
  try {
    // calculate pages to load
    const pageStart = getPageOfIndex(startIndex)
    const pageStop = getPageOfIndex(stopIndex)

    // Get params
    const loadedPages = yield select(selectLoadedPages)
    const cleanedFilter = yield select(selectFilterClean)

    // save current filter (filter applied)
    const currentFilter = {
      ...(lodash.get(cleanedFilter, 'searchType') === 'fulltext'
        ? lodash.pick
        : lodash.omit)(cleanedFilter, ['search']),
      ...lodash.pick(cleanedFilter, ['usePickupAddress', 'useDeliveryAddress']),
    }
    if (isManual) {
      yield put(setCurrentFilter(currentFilter))
    }

    // get currentFilter
    let filter = yield select(makeSelectCurrentFilter())
    let endpoint =
      lodash.get(cleanedFilter, 'searchType') === 'fulltext'
        ? 'fulltext'
        : 'search'
    if (
      endpoint === 'fulltext' &&
      lodash.get(currentFilter, 'search', '') === ''
    ) {
      endpoint = 'search'
    }

    // fix address filter
    filter = {
      ...filter,
      usePickupAddress: true,
      useDeliveryAddress: true,
    }

    // Load all pages
    for (let i = pageStart; i <= pageStop; i++) {
      // skip already loaded
      if (loadedPages[i]) {
        continue
      }

      const result = yield requestPage(
        `/api/addressbook/${endpoint}`,
        i,
        filter,
      )
      yield put(receive({ result }))
    }
  } catch (error) {
    console.error(error)
    yield put(receive({ error }))
    Sentry.captureMessage(error, {
      extra: { saga, payload },
    })
  }
}

export function* handleRequestAdd({ payload, payload: { values, update } }) {
  try {
    const url = `/api/addressbook${update ? `/${values.id}` : ''}`
    const method = update ? 'patch' : 'put'
    const { data, status } = yield request({
      method,
      url,
      data: values,
    })
    yield put(receiveAdd({ result: data }))
    toast.success(
      update ? 'Adresse wurde aktualisiert.' : 'Addresse wurde hinzugefügt.',
    )
  } catch (error) {
    console.error(error)
    Sentry.captureMessage(error, {
      extra: { saga, payload },
    })
    yield put(receiveAdd({ error }))
    toast.error(
      update
        ? 'Aktualisieren der Adresse fehlgeschlagen!'
        : 'Hinzufügen der Addresse fehlgeschlagen!',
    )
  }
}

export function* handleApplyFilter() {
  yield handleRequest({
    payload: { startIndex: 0, stopIndex: 1, isManual: true },
  })
}
